module.exports = __webpack_public_path__ + "img/mso_system.59c3f9e4.png";